import { render, staticRenderFns } from "./LineaTiempoD.vue?vue&type=template&id=167e30f9&lang=pug&"
import script from "./LineaTiempoD.vue?vue&type=script&lang=js&"
export * from "./LineaTiempoD.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports